import React from 'react'
import AdminComptableRegister from '../../Components/AdminComponents/AdminComptableRegister.jsx'

const AdminComptableRegisterPage = () => {
  return (
    <div><AdminComptableRegister /></div>
  )
}

export default AdminComptableRegisterPage